import { useCallback } from "react";

import { dealNetworkService } from "@/api/dealNetwork";
import { ConnectRequestConfirmationPage } from "@/pages/PublicConnect/ConnectRequestConfirmationPage";

type TInvestorConnectPageProps = {
  connectRequestId?: string;
};

export function InvestorConnectPage({ connectRequestId }: TInvestorConnectPageProps) {
  const confirmRequest = useCallback(
    (connectRequest: string) => dealNetworkService.createInvestorConnectRequestIntroduction(connectRequest),
    []
  );

  return (
    <ConnectRequestConfirmationPage
      connectRequestId={connectRequestId}
      confirmRequest={confirmRequest}
    />
  );
}
